import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  stroke: var(--white);

  height: 18px;
  width: 18px;

  // transition: transform 0.1s ease-in 25ms;
  // transform: scale(0);
`;

const Tick = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    className="tick"
    data-testid="success-icon"
  >
    <path fill="none" strokeWidth="3" d="M1.73 12.91l6.37 6.37L22.79 4.59" />
  </Svg>
);

export default Tick;
